<template>
	<div class="ui-gold" :class="{ reverse }">
		<div class="value">{{ value }}</div>
		<div class="icon bg" v-bg="'cards/gold/emerald.png'"></div>
	</div>
</template>

<script>
export default {
	name: 'ui-gold',
	props: {
		value: { default: 0 },
		reverse: { default: false }
	},
}
</script>

<style lang="stylus" scoped>

.ui-gold
	inline-flex center center
	&.reverse
		flex-direction row-reverse
		.icon
			margin 0 8px 0 0
	.icon
		width 24px
		height 40px
		margin 0 0 0 8px
		background center center no-repeat
		background-size contain
			

</style>
